import { SELECT_DEALER } from 'constants/ActionTypes';
import * as types from 'modules/predefinedMessages/actionTypes';

import { createReducer } from 'utils/ReduxUtils';

/** @type {Object<string, any>} State */
const initialState = {};

/**
 *
 * @param {Object<string, any>} state
 * @param {import('../../../types').SetDashboardFiltersAction} action
 */
const setFilters = (state, { payload: filters }) => ({
  ...state,
  ...filters,
});

/**
 * @param {Object<string, any>} state
 * @param {import('../../../types').RemoveDashboardFiltersAction} action
 */
const removeFilter = (state, { payload: field }) => {
  const { [field]: omitted, ...newState } = state;
  return newState;
};

const clearFilters = () => initialState;

export default createReducer(initialState, {
  [types.SET_DASHBOARD_FILTERS]: setFilters,
  [types.REMOVE_DASHBOARD_FILTERS]: removeFilter,
  [SELECT_DEALER]: clearFilters,
});
